var exports = {
  "kL": "xfb577c5e--c888cc--container",
  "u": "xfb577c5e--c888cc--crumb",
  "UE": "xfb577c5e--c888cc--arrow",
};

module.exports = exports;
